import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const addOrupdatePlanOrder = createAsyncThunk(
  "plan-order/addOrupdatePlanOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-customer-meal-plan",
        payload,
      );
      console.log("The res of add order from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.data?.message || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getSubscribedMealList = createAsyncThunk(
  "plan-order/getSubscribedMealList",
  async ({ service_provider_customer_id, page = 1 }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/list-customer-meal-plans", {
        params: {
          service_provider_customer_id, 
          page,
        },
      });

      // console.log(
      //   "the res of getting customer meal plan list from thunk is :",
      //   res.data,
      // );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    }
  },
);

export const onHoldPlan = createAsyncThunk(
  "plan-order/onHoldPlan",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/hold-meal-plan", payload);
      // console.log("The res of holding meal plan from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const onResumePlan = createAsyncThunk(
  "plan-order/onResumePlan",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/resume-meal-plan", payload);
      // console.log("the res of resume meal plan from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const onRenewPlan = createAsyncThunk(
  "plan-order/onRenewPlan",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/renew-meal-plan", payload);
      // console.log("The response of renew meal from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);
export const onCancelPlan = createAsyncThunk(
  "plan-order/onRenewPlan",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/cancel-meal-plan", payload);
      // console.log("The response of renew meal from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getCustomerMealPlan = createAsyncThunk(
  "plan-order/getCustomerMealPlan",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-customer-meal-plan", payload);
      // console.log("The customer meal plan from api thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err || "Something went wrong");
    }
  },
);
